import { createSlice } from '@reduxjs/toolkit';

import GetShakhsSalesBimehNamehByShomarehBimehNameh from 'Feature/Khodro/ShakhsSales/Thunks/GetShakhsSalesBimehNamehByShomarehBimehNameh';
import printBimehNamehShakhsSales from 'Feature/Khodro/ShakhsSales/Thunks/printBimehNamehShakhsSales';

import ShakhsSalesBimehNamehDetailInitialState from './ShakhsSalesBimehNamehDetailInitialState';

export const ShakhsSalesBimehNamehDetailSlice = createSlice({
  name: 'ShakhsSales/BimehNamehDetail',
  initialState: ShakhsSalesBimehNamehDetailInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetShakhsSalesBimehNamehByShomarehBimehNameh.pending, (state) => {
        state.loading = true;
        state.data = ShakhsSalesBimehNamehDetailInitialState.data;
      })
      .addCase(GetShakhsSalesBimehNamehByShomarehBimehNameh.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload !== undefined) {
          state.data = action.payload;
        }
        return state;
      })
      .addCase(GetShakhsSalesBimehNamehByShomarehBimehNameh.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehShakhsSales.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehShakhsSales.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehShakhsSales.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default ShakhsSalesBimehNamehDetailSlice.reducer;
